import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { BrManageContentButton } from '@bloomreach/react-sdk';
import { WebPage } from '@grandvisionhq/analytics';
import { monetate } from '@grandvisionhq/svc-monetate';
import CmsSeo from '../containers/Seo/Seo.js';
import CmsPageLayout from '../layouts/Page.js';
import CmsComponentSlot from '../containers/Slot/Slot.js';
import { useBrPageContext, useBrComponentContext } from '../context/context.js';
import CmsBlogLayout from '../layouts/Blog.js';
import CmsContentLayout from '../layouts/Content.js';
import { getPageSeo } from '../utils/get-page-seo.js';

const isBlogArticle = (content)=>content.type === 'blogArticle'
;
const ContentPageType = ()=>{
    const page = useBrPageContext();
    const pageSeo = getPageSeo(page);
    const component = useBrComponentContext();
    var ref;
    const { document: documentRef  } = (ref = component === null || component === void 0 ? void 0 : component.getModels()) !== null && ref !== void 0 ? ref : {};
    var ref1;
    const pageName = (ref1 = page === null || page === void 0 ? void 0 : page.getComponent().getName()) !== null && ref1 !== void 0 ? ref1 : '';
    const document = page === null || page === void 0 ? void 0 : page.getContent(documentRef);
    const content = document === null || document === void 0 ? void 0 : document.getData();
    React.useEffect(()=>{
        monetate().commitMonetateEvent('other_page');
    }, []);
    if (!content) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(React.Fragment, null, document && /*#__PURE__*/ React.createElement(BrManageContentButton, {
        content: document
    }), isBlogArticle(content) ? /*#__PURE__*/ React.createElement(CmsBlogLayout, {
        content: content
    }) : /*#__PURE__*/ React.createElement(CmsContentLayout, {
        content: content,
        pageName: pageName
    }), pageSeo && content && /*#__PURE__*/ React.createElement(WebPage, {
        pageType: "Information",
        url: pageSeo.canonicalUrl,
        name: content.title,
        description: content.summary
    }));
};
const CmsContentPage = (props)=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(CmsSeo, null), /*#__PURE__*/ React.createElement(CmsPageLayout, swcHelpers.extends({}, props), /*#__PURE__*/ React.createElement(CmsComponentSlot, {
        path: "main/content"
    }, /*#__PURE__*/ React.createElement(ContentPageType, null))));
};
var CmsContentPage$1 = CmsContentPage;

export { CmsContentPage$1 as default };
//# sourceMappingURL=content.js.map
